import { Archive, Layers, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function BulkCard({ busy, batchGenerate, downloadZip }) {
  return (
    <Card className="shadow-none" data-testid="exports-bulk-card">
      <CardContent className="flex flex-wrap items-center justify-between gap-3 p-4">
        <div className="flex items-center gap-3">
          <Layers className="h-5 w-5 text-blue-900" />
          <div>
            <p className="font-semibold text-slate-950">Rigenerazione batch</p>
            <p className="text-sm text-slate-500">Genera tutti i 6 documenti standard (DVR PDF/DOCX, miglioramento, DPI, formazione, scadenze) in un&apos;unica operazione.</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button onClick={batchGenerate} disabled={busy === "batch"} className="bg-blue-900 hover:bg-blue-800" data-testid="batch-generate-button">
            {busy === "batch" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Layers className="h-4 w-4" />}
            {busy === "batch" ? "Generazione batch..." : "Rigenera tutti"}
          </Button>
          <Button variant="outline" onClick={() => downloadZip("")} data-testid="download-zip-all-button">
            <Archive className="h-4 w-4" /> Scarica ZIP completo
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
